import React, { Fragment, useState, useEffect } from "react";
import QrReader from 'react-qr-scanner'
import Swal from "sweetalert2";
import { getIdenticator } from '../../api/directory';
import { useNavigate, useLocation } from "react-router";
import FContainer from "../../components/FContainer/FContainer";
import Fbutton from "../../components/Finputs/FButton/Fbutton";
import { useProcessor } from "../../hooks/useProcessor";
import { v4 as uuidv4 } from 'uuid';

const QrDynamicScreen = ({ param }) => {
  const [idempotencyKey, setIdempotencyKey] = useState(null);
  const { processPayment } = useProcessor();

  const route = useNavigate();
  const { state } = useLocation();

  useEffect(() => {
    setIdempotencyKey(uuidv4());
  }, []);

  const nextScreen = async () => {
    const monto = parseInt(state.amount)
    const data = {
      originCurrencyId: "484",
      destinationCurrencyId: "484",
      exchangeRateId: null,
      products: [
          {
              id: "FIADO_FUNDS_AVAILABLE_MXN"
          },
          {
              id: "FIADO_SHARE_MXN",
              amount: monto,
              beneficiaryDirectoryId: state.directoryId,
              phoneNumber: JSON.parse(localStorage.getItem("tokenDecoded")).phone_number,
              typeOfDirectoryId:JSON.parse(localStorage.getItem("tokenDecoded")).typeOfDirectoryId,
              concept: state.concept,
              saveAsFavorite: false
          }  
      ]
  }


    let response = await processPayment(data, idempotencyKey);
    if (response?.data?.code == "PROCESS_OK") {
      Swal.fire({
        showCloseButton: true,
        title: 'Éxito',
        text: 'La transferencia se ha realizado exitosamente',
        icon: 'success',
        showCancelButton: false,
        confirmButtonColor: '#fd6e0d',
        // iconColor: "#fd6e0d",
        confirmButtonText: 'Entendido'
      }).then((result) => {
        if (result.isConfirmed) {
          route("/ShareFiadoScreen")
        } else {
          route("/ShareFiadoScreen")
        }
      })
    } else {

      Swal.fire({
        showCloseButton: true,
        title: 'Advertencia',
        text: "Su solicitud no puede ser procesada",
        icon: 'warning',
        showCancelButton: false,
        confirmButtonColor: '#fd6e0d',
        confirmButtonText: 'Entendido'
      })
    }
  }

  return (
    <>    {!state ? route("/ShareFiadoScreen") :
      <FContainer>
        <div className="font-bold text-[17px]">Para: {state.name}</div>
        <div className="font-bold text-[17px]">Cantidad a enviar: ${state.amount} MXN</div>
        <div className="font-bold text-[17px]">Concepto: {state.concept}</div>
        <Fbutton value="Enviar" onClick={()=>{
          nextScreen()
        }}></Fbutton>
      </FContainer>}
    </>
  );
};

export default QrDynamicScreen;
